import React from 'react';
import { useTranslation } from 'react-i18next';
import {EmailIcon, Logo, TelegramIcon} from '../../assets';

import './Footer.css';
import {CONTACT_EMAIL, CONTACT_TG} from "../../App.config";

export const Footer: React.FC = () => {
    const { t } = useTranslation();

    return (
        <footer className="Footer">
            <div className="Footer-navigation-container">
                <div className="Footer-navigation-item">
                    <a href="#header" className="Footer-logo">
                        <Logo/>
                        <span className="Footer-text">{t('footer.slogan')}</span>
                    </a>
                    <div className="Footer-contacts">
                        {t('footer.contactUs')}
                        <a href={`mailto:${CONTACT_EMAIL}`} className="Footer-contact" aria-label="Contact us by email">
                            <EmailIcon className="Footer-icon"/>
                        </a>
                        <a href={CONTACT_TG} className="Footer-contact" aria-label="Contact us by telegram">
                            <TelegramIcon className="Footer-icon"/>
                        </a>
                    </div>
                </div>
              <nav className="Footer-navigation">
                <a href="#research" className="Footer-link">{t('header.research')}</a>
                <a href="#cases" className="Footer-link">{t('header.cases')}</a>
                <a href="#why" className="Footer-link">{t('header.about')}</a>
                <a href="#prices" className="Footer-link">{t('header.prices')}</a>
                <a href="#trial" className="Footer-link">{t('header.trial')}</a>
              </nav>
            </div>
          <span className="Footer-text Footer-copyright">{t('footer.copyright')} {new Date().getFullYear()}</span>
        </footer>
    );
};
